import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import DisasterPreparednessTrainingDetails from '../../subdepartmentdetails/DisasterPreparednessTraining'


function DisasterPreparednessTraining() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Disaster Preparedness and Training || Emergency Management";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Emergency Management"
            title="Disaster Preparedness Training"
            subtitledown="Department of Emergency Management"
           />
            <DisasterPreparednessTrainingDetails/>
        </div>
    </>
  )
}

export default DisasterPreparednessTraining